import sendHttpPostRequest from "./sendHttpPostRequest";
import sendHttpGetRequest from "./sendHttpGetRequest";

const PublicService = {
  getPublicProfilePic: (userId) => {
    return sendHttpPostRequest(
      "/public/user/getpublicprofilepic",
      JSON.stringify({
        userId: userId,
      })
    );
  },
  getConsultants: () => {
    return sendHttpGetRequest("/public/users");
  },
  getConsultant: (userId) => {
    return sendHttpPostRequest(
      "/public/user",
      JSON.stringify({
        userId: userId,
      })
    );
  },
};
export default PublicService;
